import React from "react";
import { Typography, Container, Button } from "@mui/material";
import { styled } from "@mui/system";
import InvestmentImage from "../../assets/images/Investment.jpg";
import { useNavigate } from "react-router-dom";
import { useUser } from '../../context/UserContext';

const HeroWrapper = styled("div")({
  position: "relative",
  textAlign: "center",
  color: "#fff",
  backgroundImage: `url(${InvestmentImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  height: "750px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginTop :"30px",
  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
});

const ContentBox = styled("div")({
  backgroundColor: "rgba(90, 40, 125)",
  padding: "24px",
  borderRadius: "8px",
  backdropFilter: "blur(5px)",
  width: "100%",
  maxWidth: "47%",
  wordWrap: "break-word",
  textAlign:'left',
  position: "relative", // Allows precise positioning
  left: "-4%",
  '@media (max-width: 768px)': {
    maxWidth: "80%", // Adjust as needed for smaller screens
    left: "-3%",
  },
});

const HeroButton = styled(Button)({
  marginTop: "16px",
  color: "#fff",
  borderColor: "#fff",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
});



const Hero = () => {
  const {userData} =useUser();
  const isLoggedIn =  userData !== null ? true : false;
  const navigate = useNavigate();
  const handleClick =()=>{
    isLoggedIn ? navigate('/invest')  : navigate('/Signup');
  }
  return (
    <HeroWrapper>
      <Container style={{position:'absolute', bottom:'15%'}}>
        <ContentBox>
          <Typography variant="h4" style={{ marginBottom: "16px" }}>
            Discover Smart Investment Opportunities
          </Typography>
          <Typography variant="body1" style={{ marginBottom: "24px" }}>
            Start building your financial future with secure and intelligent
            investment choices.
          </Typography>
          <HeroButton onClick = {handleClick} variant="outlined">Get Started</HeroButton>
        </ContentBox>
      </Container>
    </HeroWrapper>
  );
};

export default Hero;